import { IsNotEmpty, IsString, Length } from 'class-validator';

export class UserResetPasswordDto {
  @IsString()
  @IsNotEmpty()
  @Length(8, 30)
  password!: string;
}
